module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/rosenthal_tac_social_media_spot_small.jpg";